var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                staticClass: "btn-bus200",
                attrs: { type: "button" },
                on: { click: _vm.enviarComprobantes }
              },
              [
                _c("i", { staticClass: "fa fa-send" }),
                _c("span", [_vm._v("Enviar comprobantes")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-info btn--bigger",
                attrs: { type: "button" },
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _vm._v(" "),
                _c("span", [_vm._v("Consultar")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field" }, [
                _c("label", { attrs: { for: "todosComprobantes" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.todos_comprobantes,
                        expression: "form.todos_comprobantes"
                      }
                    ],
                    attrs: { type: "checkbox", id: "todosComprobantes" },
                    domProps: {
                      checked: Array.isArray(_vm.form.todos_comprobantes)
                        ? _vm._i(_vm.form.todos_comprobantes, null) > -1
                        : _vm.form.todos_comprobantes
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.form.todos_comprobantes,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.form,
                                "todos_comprobantes",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.form,
                                "todos_comprobantes",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.form, "todos_comprobantes", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("Consultar todos los tipos de comprobante")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.form.todos_comprobantes,
                    expression: "!form.todos_comprobantes"
                  }
                ],
                staticClass: "col-xs-12 col-md-4"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "form-field select2",
                    class: { "select2--disabled": _vm.form.todos_comprobantes }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "select2-field select2-field--stretch" },
                      [
                        _c("v-select", {
                          attrs: {
                            options: _vm.tiposComprobante,
                            label: "descripcion",
                            id: "tipoComprobante",
                            placeholder: "Seleccione..."
                          },
                          model: {
                            value: _vm.selectedTipoComprobante,
                            callback: function($$v) {
                              _vm.selectedTipoComprobante = $$v
                            },
                            expression: "selectedTipoComprobante"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "label-nowrap",
                            attrs: { for: "tipoComprobante" }
                          },
                          [_vm._v("Tipo de comprobante")]
                        )
                      ],
                      1
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field" }, [
                _c("label", { attrs: { for: "enCola" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.en_cola,
                        expression: "form.en_cola"
                      }
                    ],
                    attrs: { type: "checkbox", id: "enCola" },
                    domProps: {
                      checked: Array.isArray(_vm.form.en_cola)
                        ? _vm._i(_vm.form.en_cola, null) > -1
                        : _vm.form.en_cola
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.form.en_cola,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(_vm.form, "en_cola", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.form,
                                  "en_cola",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.form, "en_cola", $$c)
                          }
                        },
                        _vm.consultar
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Mostrar los documentos en cola")])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "table-responsive" }, [
            _c("table", [
              _c("thead", [
                _c("tr", [
                  _c(
                    "th",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.form.en_cola,
                          expression: "!form.en_cola"
                        }
                      ]
                    },
                    [
                      _c(
                        "label",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.comprobantes.length > 0,
                              expression: "comprobantes.length > 0"
                            }
                          ],
                          attrs: {
                            tooltip: "Seleccionar todo",
                            "tooltip-position": "right",
                            for: "todos"
                          }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.todos,
                                expression: "todos"
                              }
                            ],
                            attrs: { type: "checkbox", id: "todos" },
                            domProps: {
                              checked: Array.isArray(_vm.todos)
                                ? _vm._i(_vm.todos, null) > -1
                                : _vm.todos
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$a = _vm.todos,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 && (_vm.todos = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.todos = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.todos = $$c
                                  }
                                },
                                _vm.seleccionarTodos
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _c("span")
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("th", [_vm._v("Tipo de documento")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("# Documento")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Fecha de emisión")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Cliente")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Total")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Error SRI")]),
                  _vm._v(" "),
                  _c("th")
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _c(
                    "tr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.comprobantes.length === 0,
                          expression: "comprobantes.length === 0"
                        }
                      ]
                    },
                    [
                      _c(
                        "td",
                        { attrs: { colspan: !_vm.form.en_cola ? 8 : 7 } },
                        [_c("strong", [_vm._v("No se encontró registros.")])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.comprobantes, function(comprobante, index) {
                    return _c(
                      "tr",
                      {
                        key: index,
                        class: {
                          "tr--canceled": comprobante.tiene_error === "S",
                          "tr--pending": comprobante.fecha_futura === "S"
                        }
                      },
                      [
                        _c(
                          "td",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.form.en_cola,
                                expression: "!form.en_cola"
                              }
                            ]
                          },
                          [
                            _c(
                              "label",
                              { attrs: { for: "comprobante" + index } },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.comprobantesSeleccionados,
                                      expression: "comprobantesSeleccionados"
                                    }
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    id: "comprobante" + index
                                  },
                                  domProps: {
                                    value: comprobante.id_comprobante,
                                    checked: Array.isArray(
                                      _vm.comprobantesSeleccionados
                                    )
                                      ? _vm._i(
                                          _vm.comprobantesSeleccionados,
                                          comprobante.id_comprobante
                                        ) > -1
                                      : _vm.comprobantesSeleccionados
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.comprobantesSeleccionados,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = comprobante.id_comprobante,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.comprobantesSeleccionados = $$a.concat(
                                              [$$v]
                                            ))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.comprobantesSeleccionados = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.comprobantesSeleccionados = $$c
                                      }
                                    }
                                  }
                                }),
                                _c("span")
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(comprobante.tipo_comprobante.descripcion) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(comprobante.numero_documento))
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(comprobante.fecha_emision_comprobante))
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(comprobante.cliente.nombre))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              comprobante.valor_total !== null
                                ? "$" +
                                    parseFloat(
                                      comprobante.valor_total
                                    ).toLocaleString(_vm.locale)
                                : ""
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                comprobante.tiene_error === "S" ? "Sí" : "No"
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "table-actions" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn-info btn--text",
                              attrs: { tooltip: "Visualizar", type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.visualizarComprobante(comprobante)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-eye" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn-secondary btn--text",
                              attrs: { type: "button", tooltip: "Logs" },
                              on: {
                                click: function($event) {
                                  return _vm.mostrarEventosComprobante(
                                    comprobante.id_comprobante
                                  )
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-file-o" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    comprobante.en_procesamiento === "S" &&
                                    comprobante.pendiente_envio === "N",
                                  expression:
                                    "comprobante.en_procesamiento === 'S' && comprobante.pendiente_envio === 'N'"
                                }
                              ],
                              staticClass: "btn-warning btn--text",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.reenviar(index)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-share" })]
                          )
                        ])
                      ]
                    )
                  })
                ],
                2
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "eventos",
            width: "70%",
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("eventos-comprobante", {
            attrs: { idComprobante: _vm.selectedIdComprobante }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Autorización de documentos")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4adf985b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4adf985b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/Autorizacion.vue
// module id = 417
// module chunks = 0